import { getPermissionsAsync } from 'expo-notifications/build/NotificationPermissions';
import { fromPromise } from 'xstate';

import type { PushNotificationPermissionStatus } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getPushNotificationPermissionStatusActor =
  fromPromise<PushNotificationPermissionStatus>(async () => getPermissionsAsync());
